/*!
 * Studio Archive — Custom Shopify Theme
 * Built by Jacob Cain · JC Development
 * https://jacobcain.me
 */

// Developer signature in browser console
console.log(
  '%c Built by Jacob Cain · JC Development ',
  'background: #0C0C0C; color: #F7F6F3; padding: 6px 12px; font-family: monospace; font-size: 11px; letter-spacing: 0.1em;'
);
console.log('%c https://jacobcain.me', 'color: #9A9790; font-family: monospace; font-size: 11px;');

// ── HERO SCROLL LOCK ─────────────────────────────
// Lock scroll on homepage (no-scroll hero design)
const hero = document.querySelector('.hero[data-template="index"]');
if (hero) {
  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';
}

// ── PRODUCT TABS ─────────────────────────────────
document.querySelectorAll('.product-tab-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const tab = btn.dataset.tab;
    document.querySelectorAll('.product-tab-btn').forEach(b => b.classList.remove('is-active'));
    document.querySelectorAll('.product-tab-content').forEach(p => p.classList.remove('is-active'));
    btn.classList.add('is-active');
    const panel = document.querySelector('[data-tab-panel="' + tab + '"]');
    if (panel) panel.classList.add('is-active');
  });
});

// ── PRODUCT GALLERY ──────────────────────────────
document.querySelectorAll('[data-gallery-item]').forEach((item, i) => {
  if (i === 0) item.classList.add('is-active');
  item.addEventListener('click', () => {
    const newSrc = item.dataset.imageUrl;
    const mainImg = document.getElementById('product-main-img');
    if (mainImg && newSrc) {
      mainImg.style.opacity = '0';
      setTimeout(() => {
        mainImg.src = newSrc;
        mainImg.style.opacity = '1';
      }, 150);
    }
    document.querySelectorAll('[data-gallery-item]').forEach(g => g.classList.remove('is-active'));
    item.classList.add('is-active');
  });
});

// ── VARIANT SELECTOR ─────────────────────────────
document.querySelectorAll('.product-option-value').forEach(val => {
  val.addEventListener('click', () => {
    const position = val.dataset.optionPosition;
    document.querySelectorAll('[data-option-position="' + position + '"]').forEach(v => v.classList.remove('is-selected'));
    val.classList.add('is-selected');
    const form = document.getElementById('product-form');
    if (!form) return;
    const options = {};
    form.querySelectorAll('.product-option-value.is-selected').forEach(v => {
      options[v.dataset.optionPosition] = v.dataset.optionValue;
    });
    const productData = window.__productData;
    if (!productData) return;
    const match = productData.variants.find(v =>
      Object.keys(options).every(pos => v['option' + pos] === options[pos])
    );
    if (match) {
      const input = document.getElementById('variant-id-input');
      if (input) input.value = match.id;
    }
  });
});

// ── CART AJAX ────────────────────────────────────
document.addEventListener('click', async (e) => {
  const changeBtn = e.target.closest('[data-qty-change]');
  const removeBtn = e.target.closest('[data-remove-item]');

  if (changeBtn) {
    const variantId = changeBtn.dataset.variant;
    const input = document.querySelector('[data-qty-input][data-variant="' + variantId + '"]');
    if (!input) return;
    const current = parseInt(input.value, 10);
    const delta = parseInt(changeBtn.dataset.qtyChange, 10);
    const newQty = Math.max(0, current + delta);
    await updateCartItem(variantId, newQty);
  }

  if (removeBtn) {
    const variantId = removeBtn.dataset.removeItem;
    await updateCartItem(variantId, 0);
  }
});

async function updateCartItem(variantId, qty) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty })
  });
  window.location.reload();
}

// ── BFCACHE RESTORE ──────────────────────────────
window.addEventListener('pageshow', (e) => {
  if (e.persisted) window.location.reload();
});

// ── VARIANT DROPDOWN (v1.2.1) ────────────────────
document.querySelectorAll('.product-option-select').forEach(sel => {
  sel.addEventListener('change', () => {
    const form = document.getElementById('product-form');
    if (!form) return;
    const options = {};
    form.querySelectorAll('.product-option-select').forEach(s => {
      options[s.dataset.optionPosition] = s.value;
    });
    const productData = window.__productData;
    if (!productData) return;
    const match = productData.variants.find(v =>
      Object.keys(options).every(pos => v['option' + pos] === options[pos])
    );
    if (match) {
      const input = document.getElementById('variant-id-input');
      if (input) input.value = match.id;
    }
  });
});

// ── GALLERY INTERACTION (v1.2.1) ────────────────
(function() {
  document.querySelectorAll('[data-gallery-mode="carousel"]').forEach(wrap => {
    const grid = wrap.querySelector('.product-grid, .lookbook-grid, .editorial-grid');
    if (!grid) return;
    if (wrap.querySelector('.gallery-arrow')) return;

    const prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'gallery-arrow gallery-arrow--prev';
    prev.innerHTML = '‹';
    prev.setAttribute('aria-label', 'Previous');

    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'gallery-arrow gallery-arrow--next';
    next.innerHTML = '›';
    next.setAttribute('aria-label', 'Next');

    prev.addEventListener('click', () => grid.scrollBy({ left: -grid.clientWidth * 0.8, behavior: 'smooth' }));
    next.addEventListener('click', () => grid.scrollBy({ left:  grid.clientWidth * 0.8, behavior: 'smooth' }));

    wrap.appendChild(prev);
    wrap.appendChild(next);
  });

  let lightbox, images, currentIndex, lastFocus;

  function buildLightbox() {
    lightbox = document.createElement('div');
    lightbox.className = 'gallery-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.innerHTML =
      '<button type="button" class="gallery-lightbox__close" aria-label="Close">×</button>' +
      '<button type="button" class="gallery-lightbox__prev" aria-label="Previous">‹</button>' +
      '<img class="gallery-lightbox__img" alt="">' +
      '<button type="button" class="gallery-lightbox__next" aria-label="Next">›</button>' +
      '<div class="gallery-lightbox__counter"></div>';
    document.body.appendChild(lightbox);

    lightbox.querySelector('.gallery-lightbox__close').addEventListener('click', closeLightbox);
    lightbox.querySelector('.gallery-lightbox__prev').addEventListener('click', () => navigate(-1));
    lightbox.querySelector('.gallery-lightbox__next').addEventListener('click', () => navigate(1));
    lightbox.addEventListener('click', e => { if (e.target === lightbox) closeLightbox(); });

    document.addEventListener('keydown', e => {
      if (!lightbox || !lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowLeft') navigate(-1);
      else if (e.key === 'ArrowRight') navigate(1);
    });

    let startX = 0;
    lightbox.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    lightbox.addEventListener('touchend', e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) navigate(diff > 0 ? 1 : -1);
    });
  }

  function openLightbox(imgList, index) {
    if (!lightbox) buildLightbox();
    images = imgList;
    currentIndex = index;
    lastFocus = document.activeElement;
    updateLightbox();
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    lightbox.querySelector('.gallery-lightbox__close').focus();
  }

  function closeLightbox() {
    lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function navigate(delta) {
    currentIndex = (currentIndex + delta + images.length) % images.length;
    updateLightbox();
  }

  function updateLightbox() {
    lightbox.querySelector('.gallery-lightbox__img').src = images[currentIndex];
    lightbox.querySelector('.gallery-lightbox__counter').textContent = (currentIndex + 1) + ' / ' + images.length;
  }

  document.querySelectorAll('[data-gallery-mode="lightbox"], [data-gallery-mode="fullscreen"]').forEach(wrap => {
    const imgs = Array.from(wrap.querySelectorAll('img'));
    if (imgs.length === 0) return;
    const urls = imgs.map(img => img.src || img.dataset.src);
    imgs.forEach((img, i) => {
      img.addEventListener('click', e => {
        e.preventDefault();
        openLightbox(urls, i);
      });
    });
  });
})();

// ── EDITORIAL VIDEO POSTER → YOUTUBE (v1.2.1) ─────
document.querySelectorAll('.editorial-item__poster[data-youtube-id]').forEach(poster => {
  poster.addEventListener('click', () => {
    const id = poster.dataset.youtubeId;
    const wrap = document.createElement('div');
    wrap.className = 'editorial-item__iframe-wrap';
    wrap.innerHTML = '<iframe src="https://www.youtube.com/embed/' + id + '?autoplay=1" title="Video" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
    poster.replaceWith(wrap);
  });
});

// ── EMAIL POPUP (v1.2.1) ─────────────────────────
(function() {
  const popup = document.getElementById('email-popup');
  const overlay = document.getElementById('email-popup-overlay');
  if (!popup || !overlay) return;

  const trigger = popup.dataset.trigger;
  const delay = parseInt(popup.dataset.delay, 10) * 1000;
  const scrollPct = parseInt(popup.dataset.scroll, 10);
  const frequency = popup.dataset.frequency;
  const showOnMobile = popup.dataset.showMobile === 'true';
  const isMobile = window.innerWidth <= 768;

  if (isMobile && !showOnMobile) return;

  const storageKey = 'sa-popup-dismissed';
  const sessionKey = 'sa-popup-session';

  if (frequency === 'once_per_visitor' && localStorage.getItem(storageKey)) return;
  if (frequency === 'once_per_session' && sessionStorage.getItem(sessionKey)) return;

  function show() {
    popup.classList.add('is-open');
    overlay.classList.add('is-open');
    const focusable = popup.querySelector('input[type="email"]');
    if (focusable) setTimeout(() => focusable.focus(), 100);
  }
  function dismiss() {
    popup.classList.remove('is-open');
    overlay.classList.remove('is-open');
    if (frequency === 'once_per_visitor') localStorage.setItem(storageKey, '1');
    if (frequency === 'once_per_session') sessionStorage.setItem(sessionKey, '1');
  }

  if (trigger === 'delay') {
    setTimeout(show, delay);
  } else if (trigger === 'scroll') {
    let triggered = false;
    window.addEventListener('scroll', () => {
      if (triggered) return;
      const total = document.documentElement.scrollHeight - window.innerHeight;
      const pct = total > 0 ? (window.scrollY / total) * 100 : 0;
      if (pct >= scrollPct) { triggered = true; show(); }
    }, { passive: true });
  } else if (trigger === 'exit') {
    let triggered = false;
    document.addEventListener('mouseleave', e => {
      if (triggered || e.clientY > 0) return;
      triggered = true;
      show();
    });
  } else if (trigger === 'immediate') {
    show();
  }

  popup.querySelector('.email-popup__close').addEventListener('click', dismiss);
  overlay.addEventListener('click', dismiss);
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && popup.classList.contains('is-open')) dismiss();
  });

  if (popup.querySelector('.email-popup__success')) {
    setTimeout(dismiss, 3000);
  }
})();
